<template>
  <div class="footerWrap isAnimate">
    <div class="footer simple-style">
      <div class="footer_box">
        <div class="top_box">
          <!-- <div class="top_left_box">
            <div class="left_item" v-for="(item, index) in bottom_items" :key="index">
              <p>{{item.title}}</p>
              <ul>
                <li v-for="(data,i) in item.items" :key="'li' + i">{{data}}</li>
              </ul>
            </div>
          </div> -->
          <div class="top_left_box">
            <div class="left_item">
              <p>主办单位</p>
              <ul>
                <li v-for="item in info" v-if="item.bottomType==bottomInfo.zbdw">{{ item.bottomName }}</li>
              </ul>
            </div>
            <div class="left_item">
              <p>云会展服务</p>
              <ul>
                <li v-for="item in info" v-if="item.bottomType==bottomInfo.lxr" >联系人：{{ item.bottomName }}</li>
                <li v-for="item in info" v-if="item.bottomType==bottomInfo.zxdh" >咨询电话：{{ item.bottomName }}</li>
                <li v-for="item in info" v-if="item.bottomType==bottomInfo.zxyx" >咨询邮箱：{{ item.bottomName }}</li>
                <li v-for="item in info" v-if="item.bottomType==bottomInfo.zxwx" >咨询微信：{{ item.bottomName }}</li>
              </ul>
            </div>
            <div class="left_item">
              <p>云展会平台</p>
              <ul>
                <li v-for="item in info" v-if="item.bottomType==bottomInfo.dh" >电话：{{ item.bottomName }}</li>
                <li v-for="item in info" v-if="item.bottomType==bottomInfo.jszc" >技术支持：{{ item.bottomName }}</li>
              </ul>
            </div>
          </div>
          <div class="top_rigth_box">
            <div class="left_item"></div>
            <div class="qr_code">
              <div class="right_item">
                <img src="../img/qrcode.jpg">
                <p>云会展小程序</p>
              </div>
            </div>
          </div>
        </div>
        <div class="buttom_box">
          <p class="">Copyright © 2005-2024 宁夏报业传媒集团云会展有限公司 All Rights Reserved. 推荐使用 Chrome 浏览器或 Firefox 浏览器和1920*1080以上的分辨率，以获得最佳浏览效果。</p>
          <p style="margin-top: 8px;">
            <span data-v-31e804e5="" style="color: rgb(147, 147, 147);">ICP备案号：</span>
            <a href="https://beian.miit.gov.cn/" target="_blank" class="ch-link" style="text-decoration: underline;">宁ICP备2023002037号﹣1</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'
import axios from 'axios'
export default {
  name: "Bottom",
  data() {
    return {
      bottom_items: [
        {
          title: '主办单位',
          items: ['宁夏会展云平台'],
        },
        {
          title: '云会展服务',
          items: ['联系人：Lisa', '咨询电话: 13104589796', '咨询邮箱：lsac@163.com', '咨询微信：aas13845238125'],
        },
        {
          title: '云会展平台',
          items: ['电话：13845238125', '技术支持：云展会'],
        },
      ],
      info:'',
				infoType:'',
				bottomInfo:{
					zbdw:'',
					dh:'',
					jszc:'',
					lxr:'',
					zxdh:'',
					zxyx:'',
					zxwx:'',
					ewm:''
				}
    }
  },
  mounted() {
    this.getBottom();
    gsap.from('.footerWrap', {
      opacity: 0,
      y: 100,
      ease: "power3",
      duration: 3
    })
  },
  methods:{
    getBottom(){
				axios.get('/system/dict/data/type/yzh_bottom_type',{
					params:{
						// pageSize:20,
						// pageNum:pnum,
					}
				}).then((res)=>{
				    this.infoType=res.data.data
					for(var i=0;i<this.infoType.length;i++){
						if(this.infoType[i].dictLabel=='主办单位'){
							this.bottomInfo.zbdw=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='技术支持'){
							this.bottomInfo.jszc=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='电话'){
							this.bottomInfo.dh=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='联系人'){
							this.bottomInfo.lxr=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='咨询电话'){
							this.bottomInfo.zxdh=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='咨询邮箱'){
							this.bottomInfo.zxyx=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='咨询微信'){
							this.bottomInfo.zxwx=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='二维码'){
							this.bottomInfo.ewm=this.infoType[i].dictValue
						}
					}
					// console.log(this.info)

				})
        axios.get('/web/bottom/list',{
					params:{
						pageSize:20,
						// pageNum:pnum,
					}
				}).then((res)=>{
				    this.info=res.data.rows
					// console.log(this.info)

				})
    }
  }
}
</script>

<style scoped>
.containerComponent .footerWrap {
  background: #f7f7f7
}
.footer {
  background: url(../img/footer_bg.png) no-repeat 50%;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
}
.footer .beiAnIcon {
  vertical-align: middle;
  margin-right: .25rem
}

.footer .footer_box {
  width: 87.5rem;
  margin: 0 auto
}

.footer .top_box {
  display: flex;
  justify-content: space-around
}

.footer .top_box .top_left_box {
  min-width: 13.75rem;
  display: flex
}

.footer .top_box .top_left_box .left_item {
  margin-right: 4rem
}

.footer .top_box .top_left_box .left_item.en {
  max-width: 25rem;
  margin-right: 0;
  padding-right: 1.25rem
}

.footer .top_box .left_item {
  max-width: 19.375rem;
  margin-top: 4.75rem
}

.footer .top_box .left_item p {
  font-size: 1.25rem;
  font-family: PingFangSC-Medium,PingFang SC;
  font-weight: 700;
  color: #333;
  line-height: 1.75rem
}

.footer .top_box .left_item ul {
  margin-top: 1.875rem
}

.footer .top_box .left_item li {
  font-size: 1.125rem;
  font-family: PingFangSC-Regular,PingFang SC;
  font-weight: 400;
  color: #333;
  line-height: 1.5625rem
}

.footer .top_box .left_item li:not(last-of-type) {
  margin-bottom: 1.5rem
}

.footer .top_box .left_item a {
  text-decoration: none;
  color: #333;
  font-size: 1.125rem
}

.footer .top_box .top_rigth_box .left_item {
  margin-bottom: 1.875rem
}

.footer .top_box .top_rigth_box .qr_code {
  display: flex
}

.footer .top_box .top_rigth_box .right_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 9.375rem
}

.footer .top_box .top_rigth_box .right_item:first-of-type {
  margin-right: 1.625rem
}

.footer .top_box .top_rigth_box .right_item img {
  margin-top: auto;
  max-width: 7.6875rem;
  max-height: 7.6875rem
}

.footer .top_box .top_rigth_box .right_item p {
  width: 9.375rem;
  word-wrap: break-word;
  text-align: center;
  font-size: .875rem;
  font-weight: 400;
  color: #333;
  line-height: 2rem;
  margin-top: 1.375rem;
  line-height: 1.2;
  max-height: 2.125rem;
  word-break: break-word
}

.footer .buttom_box {
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: .0625rem solid #373738;
  flex-direction: column;
  padding: 1.875rem 0 .625rem
}

.footer .buttom_box p {
  margin-top: 1.75rem;
  margin-bottom: .5rem;
  text-align: center;
  width: 78.125rem;
  font-size: .875rem;
  font-family: PingFangSC-Regular,PingFang SC;
  font-weight: 400;
  color: #333;
  line-height: 1.25rem
}

.footer .buttom_box .ch-link {
  color: #939393;
  text-decoration: none;
  cursor: pointer
}

.footer .buttom_box .smallScreen {
  font-size: .75rem
}

.footer .buttom_box ul {
  display: flex
}

.footer .buttom_box ul li {
  margin-right: 2.125rem;
  line-height: 0
}

.footer .buttom_box ul li img {
  display: inline-block;
  height: 1.25rem
}

.footer .ch-link {
  color: #333;
  text-decoration: none;
  cursor: pointer
}

.footer .aboutUs {
  cursor: pointer
}

.footer.chinese-style,.footer.dark-style {
  background: #333
}

.footer.chinese-style .top_box .left_item li,.footer.chinese-style .top_box .left_item p,.footer.dark-style .top_box .left_item li,.footer.dark-style .top_box .left_item p {
  color: #fff
}
</style>
